
export function setCookieSet(name, set) {
    const value = JSON.stringify(Array.from(set));
    document.cookie = `${name}=${encodeURIComponent(value)};path=/`;
    // const expires = new Date();
    // expires.setTime(expires.getTime() + (30 * 24 * 60 * 60 * 1000));
    // document.cookie = `${name}=${encodeURIComponent(value)};expires=${expires.toUTCString()};path=/`;
}


export function getSetFromCookie(name) {
    const value = document.cookie.split(';').find(row => row.trimStart().startsWith(`${name}=`));
    if (!value) {
        return new Set();
    }
    const array = JSON.parse(decodeURIComponent(value.split('=')[1]));
    return new Set(array);
}


export function setCookieString(name, str) {
    document.cookie = `${name}=${encodeURIComponent(str)};path=/`;
}


export function getStringFromCookie(name) {
    const value = document.cookie.split(';').find(row => row.trimStart().startsWith(`${name}=`));
    if (!value) {
        return "";
    } else {
        return decodeURIComponent(value.split('=')[1]);
    }
}
